export default {
    topics: [
        {
            title: ' GenerateVolumeLines ',
            href: 'sm-typologyRule-GenerateVolumeLines.html',
            attributes: { 'data-id': 'sm-typologyRule-GenerateVolumeLines' },
            menu: { hasChildren: false },
            tocID: 'sm-typologyRule-GenerateVolumeLines-d66e4088',
            topics: [],
        },
    ],
};

